// extracted by mini-css-extract-plugin
module.exports = {"teas":"AvailableTeas_teas__15zwB","teas-appear":"AvailableTeas_teas-appear__2910f"};